import * as React from "react";
import { css } from "@emotion/core";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  Button,
  CardList,
} from "@blueprintjs/core";

interface ConfirmRemoveDialogProps<T> {
  onCancel: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

export function ConfirmRemoveDialog<T>({
  onCancel,
  onConfirm,
  children,
}: ConfirmRemoveDialogProps<T>) {
  return (
    <Dialog
      title="Confirm Remove"
      icon="trash"
      isOpen
      className="bp6-dark"
      onClose={onCancel}
    >
      <DialogBody
        css={css`
          display: flex;
          flex-direction: column;
          gap: 1rem;
        `}
      >
        <div>
          <CardList>{children}</CardList>
        </div>
      </DialogBody>
      <DialogFooter
        actions={[
          <Button key="cancel" text="Cancel" onClick={onCancel} />,
          <Button
            key="confirm"
            intent="danger"
            text="Confirm"
            onClick={onConfirm}
          />,
        ]}
      />
    </Dialog>
  );
}
